import React from "react";
import { Link } from "react-router-dom";

/**
 * NotFound — catch-all `*` route (SEO plan Phase 1b).
 *
 * The server returns this shell with a real 404 status for unknown paths, so
 * crawlers see a Not Found while users get a way back. Reuses the auth-gate
 * card styling so it matches the other single-card pages.
 */
export default function NotFound() {
  return (
    <div className="auth-gate">
      <div className="auth-gate__card">
        <h2 className="auth-gate__title">Page not found</h2>
        <p className="auth-gate__text">
          We couldn{"’"}t find that page. It may have moved, or the link may be
          mistyped.
        </p>
        <Link to="/" className="btn btn--primary">
          Back to home
        </Link>
      </div>
    </div>
  );
}
